import React from 'react';
import PropTypes from 'prop-types';

import Table from '@modules/app/components/Table';

import spiideoCompetitorMappingsTableColumns from './SpiideoCompetitorMappingsTable/spiideoCompetitorMappingsTableColumns';
import spiideoCompetitorMappingsTableRowRenderer from './SpiideoCompetitorMappingsTable/spiideoCompetitorMappingsTableRowRenderer';

const SpiideoCompetitorMappingsTable = ({spiideoCompetitorMappings = [], loading}) => (
    <div className='spiideoCompetitorMappings__table'>
        <Table
            name='spiideoCompetitorMappingsList'
            columns={spiideoCompetitorMappingsTableColumns}
            data={spiideoCompetitorMappings}
            loading={loading}
            rowRenderer={spiideoCompetitorMappingsTableRowRenderer}
            noDataText='No Spiideo competitor mappings found'
            defaultSort='sport'
        />
    </div>
);

SpiideoCompetitorMappingsTable.propTypes = {
    spiideoCompetitorMappings: PropTypes.array,
    loading: PropTypes.bool,
};

export default SpiideoCompetitorMappingsTable;
